import { z } from 'zod';

import { WorkoutPlanId } from '../../BrandedIds';
import { BaseLoanEvent } from '../BaseLoanEvent';

/*
 Workout plans that were mistakenly added and should not be reported
*/
export const ArchiveWorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('archiveWorkoutPlan'),
  workoutPlanId: WorkoutPlanId,
});
export type ArchiveWorkoutPlanEvent = z.infer<typeof ArchiveWorkoutPlanEvent>;
